import { render } from "./TemporaryPage.vue?vue&type=template&id=fa46ba38"
import script from "./TemporaryPage.vue?vue&type=script&lang=js"
export * from "./TemporaryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__